import { PriceRoundingBrand } from '@retail/rounding/types';
import { DraftConditionDTO } from '../dtos';
import { ConditionsNew } from './ConditionsNew';

interface DraftConditionProps {
  condition: ConditionsNew;
  replacesCondition?: ConditionsNew;
}

export class DraftCondition {
  condition: ConditionsNew;
  replacesCondition?: ConditionsNew;

  constructor({ condition, replacesCondition }: DraftConditionProps) {
    this.condition = condition;
    this.replacesCondition = replacesCondition;
  }

  static fromDto = (dto: DraftConditionDTO, selectedBrand: PriceRoundingBrand): DraftCondition =>
    new DraftCondition({
      condition: ConditionsNew.fromDto(dto.condition, selectedBrand),
      replacesCondition: dto.replacesCondition
        ? ConditionsNew.fromDto(dto.replacesCondition, selectedBrand)
        : undefined,
    });
}
